import { TAccount } from '@helpers/Accounts/accounts.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconArrowRight } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import IwLink from '@iwRouter/IwLink';
import { FormattedMessage } from 'react-intl';

import { useGetAccountCardData } from './useGetAccountCardData';
import { LoanStatusPill } from '../../multiLoanDashboard/dashboardWidgets/loanStatusPill/LoanStatusPill';
import { LoanTitle } from '../../multiLoanDashboard/dashboardWidgets/loanTitle/LoanTitle';
import { Rate } from '../../ui/rate';

export const AccountCard = ({
    account
}: {
    account: NonNullable<TAccount>;
}) => {
    const { loanStatus, outstandingBalance, interest } =
        useGetAccountCardData(account);
    return (
        <IwLink
            to={`/dashboard/${account.account_id!}/`}
            className="col-span-5 text-left"
        >
            <div
                className="col-span-full my-xs grid cursor-pointer grid-cols-5 rounded-l border border-secondary-90 p-xl"
                data-testid="account-card"
            >
                <Text className="col-span-4 text-l font-bold">
                    <LoanTitle accountId={account.account_id!} />
                </Text>

                <div className="col-span-1 flex items-start justify-end">
                    <LoanStatusPill loanStatus={loanStatus} />
                </div>
                <Text className="col-span-4 text-s">
                    <FormattedMessage
                        id="_.dashboard_home.product_card.account_interest"
                        defaultMessage="You're paying {interest} interest per month."
                        values={{ interest: <Rate value={interest!} /> }}
                    />
                </Text>
                <Text className="col-span-4 my-l text-l">
                    <FormattedMessage
                        id="_.dashboard_home.product_card.outstanding_balance"
                        defaultMessage="Outstanding Balance: {balance}"
                        values={{
                            balance: (
                                <span className="font-bold">
                                    <FormattedCurrency
                                        value={outstandingBalance!}
                                    />
                                </span>
                            )
                        }}
                    />
                </Text>
                <div className="col-span-1 flex items-end justify-end">
                    <IconArrowRight fontSize={24} />
                </div>
            </div>
        </IwLink>
    );
};
